import React, { useEffect, useState } from 'react';
import api from '../services/api';
import type StudyModel from '../models/StudyModel';
import type QuestionModel from '../models/QuestionModel';
import LoadingSpinner from './LoadingSpinner';
import StudySearchField from './StudySearchField';
import QuestionSearchField from './QuestionSearchField';

type PropTypes = {
    onQuestionCreated: () => void;
    study?: StudyModel;
};

function CreateStudyQuestionForm({ onQuestionCreated, study }: PropTypes) {
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [selectedStudy, setSelectedStudy] = useState(
        study ?? ({} as StudyModel), // eslint-disable-line @typescript-eslint/consistent-type-assertions
    );
    const [selectedQuestion, setSelectedQuestion] = useState(
        {} as QuestionModel,
    );

    useEffect(() => {
        setError('');
    }, [selectedStudy, selectedQuestion]);

    const handleSubmit = async () => {
        if (!selectedStudy || !selectedQuestion) {
            setError('All fields are required');
            return;
        }

        setLoading(true);
        const success = await api.addQuestionToStudy(
            Number(selectedStudy.id),
            Number(selectedQuestion.id),
        );
        setLoading(false);
        if (success) {
            onQuestionCreated();
        } else {
            setError(
                'Failed to add question to study. Please try again later.',
            );
        }
    };

    return (
        <div className="w-[300px]">
            {!study && (
                <div className="mt-2 flex items-center justify-between">
                    <label>Study:</label>
                    <StudySearchField
                        selectedStudy={selectedStudy}
                        setSelectedStudy={setSelectedStudy}
                    />
                </div>
            )}
            <div className="mt-2 flex items-center justify-between">
                <label>Question:</label>
                <QuestionSearchField
                    selectedQuestion={selectedQuestion}
                    setSelectedQuestion={setSelectedQuestion}
                />
            </div>
            {error && <div className="text-red-500 mt-2">{error}</div>}
            <button
                type="submit"
                className="btn btn-primary mt-6"
                disabled={loading || error !== ''}
                onClick={handleSubmit}
            >
                {loading ? (
                    <LoadingSpinner size={30} />
                ) : (
                    'Add Question To Study'
                )}
            </button>
        </div>
    );
}

export default CreateStudyQuestionForm;
